var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.3335 4.66683V19.3333C5.3335 20.6818 6.42778 21.7778 7.77791 21.7778H15.926C17.2757 21.7778 18.3704 20.6818 18.3704 19.3333V18.3148C18.3704 17.7526 17.9145 17.2963 17.3519 17.2963C16.7893 17.2963 16.3334 17.7526 16.3334 18.3148V19.3333C16.3334 19.5574 16.15 19.7407 15.926 19.7407H7.77791C7.55384 19.7407 7.37051 19.5574 7.37051 19.3333V4.66683C7.37051 4.44276 7.55384 4.25943 7.77791 4.25943H15.926C16.15 4.25943 16.3334 4.44276 16.3334 4.66683V5.68534C16.3334 6.24755 16.7893 6.70385 17.3519 6.70385C17.9145 6.70385 18.3704 6.24755 18.3704 5.68534V4.66683C18.3704 3.31833 17.2757 2.22241 15.926 2.22241H7.77791C6.42778 2.22241 5.3335 3.31833 5.3335 4.66683Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7621 12.5744L16.7147 15.6259C16.2018 16.1392 15.3214 15.7766 15.3214 15.0514V13.6296H11.2759C10.8261 13.6296 10.4611 13.267 10.4611 12.8148V11.1852C10.4611 10.737 10.8261 10.3704 11.2759 10.3704H15.3214V8.94855C15.3214 8.22337 16.2018 7.86078 16.7147 8.37411L19.7621 11.4256C20.079 11.7433 20.079 12.2567 19.7621 12.5744Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.9ad7882faf513ec04a087acc99aa8850.svg";
export { ForwardRef as ReactComponent };